module.exports = __webpack_public_path__ + "static/media/bg-featured-video.cedb6834.png";